/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { Todo } from "./Todo";
import {
  TodoFromJSON,
  TodoFromJSONTyped,
  TodoToJSON,
  TodoToJSONTyped,
} from "./Todo";

/**
 * /todos shows todos across many owners, so the response needs the owner's display fields to render a full CompanyCell --- name plus temperature and shipment frequency for the inline icon indicators. The detail-page Todos tabs already know their owner from page context and use the raw Todo response.
 * @export
 * @interface AssignedTodo
 */
export interface AssignedTodo {
  /**
   *
   * @type {Todo}
   * @memberof AssignedTodo
   */
  todo: Todo;
  /**
   *
   * @type {string}
   * @memberof AssignedTodo
   */
  companyName?: string | null;
  /**
   *
   * @type {string}
   * @memberof AssignedTodo
   */
  temperature?: string | null;
  /**
   *
   * @type {string}
   * @memberof AssignedTodo
   */
  shipmentFrequency?: string | null;
  /**
   *
   * @type {string}
   * @memberof AssignedTodo
   */
  carrierIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof AssignedTodo
   */
  carrierDisplayName?: string | null;
}

/**
 * Check if a given object implements the AssignedTodo interface.
 */
export function instanceOfAssignedTodo(value: object): value is AssignedTodo {
  if (!("todo" in value) || value["todo"] === undefined) return false;
  return true;
}

export function AssignedTodoFromJSON(json: any): AssignedTodo {
  return AssignedTodoFromJSONTyped(json, false);
}

export function AssignedTodoFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AssignedTodo {
  if (json == null) {
    return json;
  }
  return {
    todo: TodoFromJSON(json["todo"]),
    companyName: json["companyName"] == null ? undefined : json["companyName"],
    temperature: json["temperature"] == null ? undefined : json["temperature"],
    shipmentFrequency:
      json["shipmentFrequency"] == null ? undefined : json["shipmentFrequency"],
    carrierIdentifier:
      json["carrierIdentifier"] == null ? undefined : json["carrierIdentifier"],
    carrierDisplayName:
      json["carrierDisplayName"] == null
        ? undefined
        : json["carrierDisplayName"],
  };
}

export function AssignedTodoToJSON(json: any): AssignedTodo {
  return AssignedTodoToJSONTyped(json, false);
}

export function AssignedTodoToJSONTyped(
  value?: AssignedTodo | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    todo: TodoToJSON(value["todo"]),
    companyName: value["companyName"],
    temperature: value["temperature"],
    shipmentFrequency: value["shipmentFrequency"],
    carrierIdentifier: value["carrierIdentifier"],
    carrierDisplayName: value["carrierDisplayName"],
  };
}
